import { graphql } from 'app/generated/gql'

// The API split the retired `updateMessage(id, input)` mutation into these
// per-purpose mutations. The generated graphql() documents keep the operation
// fields and variables checked against the schema.

export const MARK_MESSAGE_READ_MUTATION = graphql(`
  mutation MarkMessageRead($id: ID!, $read: Boolean!) {
    markMessageRead(id: $id, read: $read) {
      id
      read
      archived
    }
  }
`)

export const ARCHIVE_MESSAGE_MUTATION = graphql(`
  mutation ArchiveMessage($id: ID!, $archived: Boolean!) {
    archiveMessage(id: $id, archived: $archived) {
      id
      read
      archived
    }
  }
`)

export const LINK_MESSAGE_TO_CONTACT_MUTATION = graphql(`
  mutation LinkMessageToContact($id: ID!, $contactId: String!) {
    linkMessageToContact(id: $id, contactId: $contactId) {
      id
      contactId
    }
  }
`)
